import React from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";

import {
    isMobile,
    getSolfaName,
    lengthenSolfa,
    i18nSolfa,
} from "../../../../../../../common/parameters";
import { IStateTree } from "../../../../../../store/interfaces";
import { IUser } from "../../../../../../store/user/models";

import { StyledBlackButton } from "../styles";
import { getPitch } from "../utils";
import { IProps } from "./interfaces";

const BlackButton = ({
    left,
    right,
    index,
    min,
    max,
    isLow,
    notes,
    click,
    hintNote,
    doPos,
    doOctave,
    withSolfa,
}: IProps) => {
    const { locale } = useIntl();
    const { solfaShort = false, solfaKam = false } = useSelector((state: IStateTree) => state.user as IUser);
    const action = {
        [isMobile ? "onTouchStart" : "onClick"]: (e: TouchEvent | MouseEvent) => !(index < min || index > max) && click(index, null, true, e),
    };
    let text = " ";
    if (withSolfa) {
        const pitch = getPitch({ doPos, doOctave, index });
        if (pitch.a === 0) {
            text = lengthenSolfa(i18nSolfa(getSolfaName(pitch, locale), locale, solfaKam), locale, solfaShort);
        }
    }
    return (
        <StyledBlackButton
            className={hintNote && hintNote.includes(index) ? "PulsatePiano" : undefined}
            isLow={isLow}
            disabled={index < min || index > max}
            {...action}
            left={!!left}
            right={!!right}
            selected={notes.indexOf(index) !== -1}
        >
            {text}
        </StyledBlackButton>
    );
};

export default BlackButton;
